// Food API Configuration Management
// Professional configuration extraction for food scanning and meal management services

export const FOOD_API_CONFIG = {
  // Base Configuration
  API_BASE_URL: import.meta.env.VITE_API_BASE_URL?.replace("/api", "") || "",

  // Timeout Settings
  TIMEOUT: 30000, // 30 seconds for food scanning operations
  UPLOAD_TIMEOUT: 60000, // 60 seconds for file uploads

  // Retry Configuration
  RETRY_COUNT: 3,
  RETRY_DELAY_BASE: 1000, // Base delay in ms
  RETRY_EXPONENTIAL_BACKOFF: true,

  // Cache Configuration
  CACHE: {
    FOOD_PREDICTION_TTL: 5 * 60 * 1000, // 5 minutes
    MEAL_DATA_TTL: 10 * 60 * 1000, // 10 minutes
    IMAGE_URL_TTL: 30 * 60 * 1000, // 30 minutes
    MAX_ENTRIES: 100,
    CLEANUP_INTERVAL: 5 * 60 * 1000, // 5 minutes
  },

  // File Upload Settings
  UPLOAD: {
    FOLDER_NAME: "glucera",
    MAX_FILE_SIZE: 10 * 1024 * 1024, // 10MB
    ALLOWED_TYPES: ["image/jpeg", "image/png", "image/jpg"],
    CHUNK_SIZE: 1024 * 1024, // 1MB chunks for large files
  },

  // Performance Monitoring
  PERFORMANCE: {
    ENABLE_METRICS: true,
    LOG_SLOW_REQUESTS: true,
    SLOW_REQUEST_THRESHOLD: 5000, // 5 seconds
  },
};

// API Endpoints Configuration
export const getFoodApiEndpoints = () => ({
  // Food Scanning
  analyzeFoodImage: "/food_scanner/analyze_food_image/",
  addFoodItems: "/food_scanner/add_food_items/",
  editFoodItems: (foodItemId: string) =>
    `/food_scanner/edit_food_items/${foodItemId}/`,
  deleteFoodItems: (foodItemId: string) =>
    `/food_scanner/delete_food_items/${foodItemId}/`,

  // Meal Management
  saveMeal: "/food_scanner/meal_data/save/",

  // File Utility
  uploadFile: "/file-utility/files/",

  // Image Management
  getImages: (fileName: string) => `/images/${fileName}`,
});

// Environment-specific overrides
export const getFoodApiConfig = () => {
  const config = { ...FOOD_API_CONFIG };

  // Development environment adjustments
  if (process.env.NODE_ENV === "development") {
    config.PERFORMANCE.ENABLE_METRICS = true;
    config.PERFORMANCE.LOG_SLOW_REQUESTS = true;
  }

  // Production environment optimizations
  if (process.env.NODE_ENV === "production") {
    config.CACHE.MAX_ENTRIES = 200; // More caching in production
    config.PERFORMANCE.LOG_SLOW_REQUESTS = false; // Reduce logging
  }

  return config;
};

// Configuration validation
export const validateFoodApiConfig = () => {
  const config = getFoodApiConfig();

  if (!config.API_BASE_URL) {
    throw new Error("API_BASE_URL is required in food API configuration");
  }

  // Configuration validation warnings removed

  return config;
};
